import { getClientEnvironmentDetails } from '@sm/utils';

const { isBrowser } = getClientEnvironmentDetails();

export default function getCookieValue(
  cname: string,
  defaultValue?: string
): string {
  if (!isBrowser) return '';

  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return defaultValue || '';
}
